import React, { ReactNode, useState, useContext, createContext } from 'react';
import { PublicTrip } from '../../services/public-trip.service';

interface PublicTripsContextType {
  publicTrips: PublicTrip[];
  setPublicTrips: (trips: PublicTrip[]) => void;
  activePublicTrip: PublicTrip | undefined;
  setActivePublicTrip: (trip: PublicTrip) => void;
  refreshPublicTrips: boolean;
  setRefreshPublicTrips: (refresh: boolean) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const PublicTripsContext = createContext<PublicTripsContextType | undefined>(
  undefined
);

const PublicTripsProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [publicTrips, setPublicTrips] = useState<PublicTrip[]>([]);
  const [refreshPublicTrips, setRefreshPublicTrips] = useState<boolean>(false);
  const [activePublicTrip, setActivePublicTrip] = useState<
    PublicTrip | undefined
  >(undefined);
  const [searchQuery, setSearchQuery] = useState<string>('');

  return (
    <PublicTripsContext.Provider
      value={{
        publicTrips,
        setPublicTrips,
        refreshPublicTrips,
        setRefreshPublicTrips,
        activePublicTrip,
        setActivePublicTrip,
        searchQuery,
        setSearchQuery
      }}
    >
      {children}
    </PublicTripsContext.Provider>
  );
};

const usePublicTrips = () => {
  const context = useContext(PublicTripsContext);
  if (context === undefined) {
    throw new Error('usePublicTrips must be used within a PublicTripsProvider');
  }
  return context;
};

export { PublicTripsProvider, usePublicTrips };
